import type { FunctionComponent } from "react";

import { IdleQueue } from "~/components/common/idle-queue";

import { DynamicPostiesHeaderAvatar } from "./dynamics";
import {
  ActionButton,
  Container,
  FeaturesWrapper,
  StyledDynamicHeaderSubscribeButton,
} from "./styles";
export type Props = {
  className?: string;
};

export const PostiesHeaderActions: FunctionComponent<Props> = ({ className }) => (
  <Container className={className}>
    <FeaturesWrapper>
      <ActionButton>
        <StyledDynamicHeaderSubscribeButton />
      </ActionButton>
      <ActionButton>
        <IdleQueue>
          <DynamicPostiesHeaderAvatar />
        </IdleQueue>
      </ActionButton>
    </FeaturesWrapper>
  </Container>
);

PostiesHeaderActions.displayName = "PostiesHeaderActions";
